













import { Component, Prop, Vue } from 'vue-property-decorator'


export interface IntegrationDetails {
    dispatchUrl: string|null;
    jobCompletedUrl: string|null;
}


@Component
export default class IntegrationDetailsCard extends Vue {
    @Prop() integrationDetails!: IntegrationDetails|null
}
